<template>
	<div class="">
		<!-- 头部 -->
		<el-card class="header-card">
			<div class="login-header flex between items-center">
				<div class="flex">
					<div class="logo pointer flex items-center">
						<img src="../assets/images/logo.png" style="width: 100%" alt="" />
					</div>
					<h1>账号注册</h1>
				</div>
				<div class="back pointer flex items-center flex-center">
					<span class="pointer" @click="goLogin">登陆</span>
					<span class="ml-5 mr-5">|</span>
					<span @click="goIndex">返回首页</span>
				</div>
			</div>
		</el-card>

		<!-- 表单开始 -->
		<div class="content">
			<!-- 表单 -->
			<el-form :model="registerForm" label-width="150px" :label-position="labelPosition"
				:rules="registerFormRules" ref="registerFormRef">
				<!-- 企业信息 -->
				<div class="title flex items-center flex-center">
					<h4 class="name">企业信息</h4>
					<span class="tips">Enterprise information</span>
				</div>
				<div class="acount">
					<el-row>
						<el-col :span="12" :offset="6">
							<el-form-item label="供应商类型" prop="supplierType1">
								<el-radio @change="typeChange" v-for="item in gongYingShangType" :key="item.dictValue"
									v-model="registerForm.supplierType1" :label="item.dictValue">{{ item.dictLabel }}
								</el-radio>
							</el-form-item>
							<el-form-item label="供应商细分类型" prop="supplierSubType">
								<el-checkbox-group v-if="isSubType" @change="subTypeChange" v-model="gongChengWuzi" style="width: 150%;">
									<el-checkbox v-for="item in gongYingShangSubType" :key="item.dictValue"
										:label="item.dictValue">{{ item.dictLabel }}</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item label="企业名称" prop="supplierName">
								<el-input v-model="registerForm.supplierName" placeholder="请输入企业名称"></el-input>
							</el-form-item>
							<el-form-item label="税号" prop="tariffLine">
								<el-input @input="ShuiHaoInput" v-model="registerForm.tariffLine" placeholder="请输入税号">
								</el-input>
							</el-form-item>
							<el-form-item label="营业执照" prop="businessLicense">
								<el-upload class="upload-demo" action="/api/common/upload" :on-success="fileUploadSuc"
									:show-file-list="false">
									<el-button class="upload" size="small">点击上传</el-button>
								</el-upload>
								<div v-if="registerForm.businessLicense" class="mt-10 pointer mr-15"
									@click="openImg(registerForm.businessLicense)"
									style="border: 1px solid #f1f1f1; padding: 2px; width: 40px">
									<img class="upload-img" :src="registerForm.businessLicense" alt="" />
								</div>
							</el-form-item>
							<el-form-item label="营业执照有效期" prop="licenseValidityPeriod" style="margin-bottom: 0px;">
								<el-date-picker v-model="registerForm.licenseValidityPeriod" format="yyyy- MM-dd"
									value-format="yyyy-MM-dd" type="date" placeholder="请选择营业执照有效期">
								</el-date-picker>
							</el-form-item>
							<div style="padding-left:150px;font-size: 10px;color: gray;margin-bottom: 15px;margin-top: 5px;"><span style="color: red;">注：</span>如营业执照有效期无固定期限，请选择2099-12-31</div>
							<el-form-item label="开户行" prop="depositBank">
								<el-input placeholder="请输入开户行" v-model="registerForm.depositBank"></el-input>
								<!-- <div class="flex">
                  <el-select
                    v-model="registerForm.depositBank"
                    class="selcet"
                    placeholder="请选择银行"
                  >
                    <el-option value="1">中国银行</el-option>
                  </el-select>
                 
                  <el-input
                    placeholder="请输入分行"
                    v-model="registerForm.depositBranchBank"
                  ></el-input>
                  <el-select
                    v-model="registerForm.depositBranchBank"
                    class="selcet1 ml-18"
                    placeholder="请选择分行"
                  >
                    <el-option value="1">中国银行</el-option>
                  </el-select>
                </div> -->
								<!-- <div class="mt-15">
                  <el-input
                    v-model="registerForm.openAccountName"
                    placeholder="请输入开户名称"
                  ></el-input>
                </div>
                <div class="mt-15">
                  <el-input placeholder="请输入银行账号"></el-input>
                </div>
                <div class="mt-15 flex items-center">
                  <div class="kaihu flex flex-center items-center">
                    请上传银行开户许可证<br />或公司盖章证明扫描件
                  </div>
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :on-exceed="handleExceed"
                  >
                    <el-button class="upload" size="small">点击上传</el-button>
                  </el-upload>
                </div>
                <div class="mt-15 kaihu-btn pointer">添加对公账号信息</div> -->
							</el-form-item>
							<!-- <el-form-item label="分行名称" prop="depositBranchBank">
                <el-input
                  placeholder="请输入分行名称"
                  v-model="registerForm.depositBranchBank"
                ></el-input>
              </el-form-item> -->

							<el-form-item label="开户名称" prop="openAccountName">
								<el-input placeholder="请输入开户名称" v-model="registerForm.openAccountName"></el-input>
							</el-form-item>
							<el-form-item label="对公账户" prop="bankAccount">
								<el-input oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入对公账户(银行卡号)"
									v-model="registerForm.bankAccount"></el-input>
							</el-form-item>
							<el-form-item label="开户许可证" prop="openAccountLicence">
								<el-upload class="upload-demo" action="/api/common/upload" :on-success="fileUploadSuc1"
									:show-file-list="false">
									<el-button class="upload" size="small">点击上传</el-button>
								</el-upload>
								<div v-if="registerForm.openAccountLicence" class="mt-10 pointer mr-15"
									@click="openImg(registerForm.openAccountLicence)"
									style="border: 1px solid #f1f1f1; padding: 2px; width: 40px">
									<img class="upload-img" :src="registerForm.openAccountLicence" alt="" />
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<!-- 授权信息 -->
				<div class="title flex items-center flex-center">
					<h4 class="name">授权信息</h4>
					<span class="tips">Authorization information</span>
				</div>
				<div class="acount">
					<el-row>
						<el-col :span="12" :offset="6">
							<el-form-item label="授权委托书" prop="entrustLetter">
								<!-- <div
                    v-if="registerForm.entrustLetter"
                    class="mt-10 pointer"
                    @click="openImg(registerForm.entrustLetter)"
                  >
                    <img
                      class="upload-img"
                      :src="registerForm.entrustLetter"
                      alt=""
                    />
                  </div> -->
								<div class="flex items-center">
									<el-upload class="upload-demo" action="/api/common/upload"
										:on-success="fileUploadSuc2" :on-progress="fileProgress"
										:show-file-list="false">
										<el-button class="upload" size="small">点击上传</el-button>
									</el-upload>
									<span class="mr-10">|</span>
									<span class="text pointer" @click="downMuBan">下载模板</span>
								</div>
								<div v-if="registerForm.entrustLetter" class="flex items-center">
									<i class="el-icon-document"></i>
									<span class="ml-15 mr-15">{{ fileName }}</span>
									<i style="color: #67c23a" class="el-icon-upload-success el-icon-circle-check"></i>
								</div>
							</el-form-item>
							<el-form-item label="授权委托书有效期" prop="letterValidityPeriod">
								<el-date-picker v-model="registerForm.letterValidityPeriod" format="yyyy- MM-dd"
									value-format="yyyy-MM-dd" type="date" placeholder="请选择授权委托书有效期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="被授权人" prop="authPerson">
								<el-input v-model="registerForm.authPerson" placeholder="请输入被授权人"></el-input>
							</el-form-item>
							<el-form-item label="推荐人(单位)" prop="recommender">
								<el-input v-model="registerForm.recommender" placeholder="请输入推荐人"></el-input>
							</el-form-item>
							<!-- <el-form-item label="验证码">
                <div class="flex between items-center yzm">
                  <el-input class="code" placeholder="请输入验证码"> </el-input>
                  <img
                    src=""
                    alt=""
                    style="border: 1px solid gray; width: 100px; height: 26px"
                  />
                  <div class="pointer">
                    <div class="size12 text2">看不清</div>
                    <div class="text1 size12">换一换</div>
                  </div>
                </div>
              </el-form-item> -->
							<el-form-item label="手机号码" prop="phone">
								<div class="flex between items-center phonew">
									<el-input v-model="registerForm.phone" class="phone" style="width: 232px"
										placeholder="请输入手机号码">
										<!-- <template slot="prepend">
                      <div>
                        <img src="../assets/images/code.png" alt="" />
                      </div>
                    </template> -->
									</el-input>
									<div class="code pointer" @click="getCode" v-if="isCode">
										发送验证码
									</div>
									<div class="code pointer" v-else>{{ ms }}秒后获取</div>
								</div>
							</el-form-item>
							<el-form-item label="手机验证码" prop="verifyCode">
								<el-input v-model="registerForm.verifyCode" placeholder="请输入手机验证码"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<!-- 账号信息  -->
				<div class="title flex items-center flex-center">
					<h4 class="name">账号信息</h4>
					<span class="tips">account information</span>
				</div>
				<div class="acount">
					<el-row>
						<el-col :span="12" :offset="6">
							<el-form-item label="登录名" prop="loginName">
								<el-input v-model="registerForm.loginName" placeholder="请输入登录名"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="passWord">
								<el-input v-model="registerForm.passWord" type="password" placeholder="请输入密码">
								</el-input>
							</el-form-item>
							<el-form-item label="确认密码" prop="checkPwd">
								<el-input v-model="registerForm.checkPwd" type="password" placeholder="请再次确认密码">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>

			<div class="flex flex-column flex-center items-center mt-50">
				<div class="flex items-center">
					<el-checkbox v-model="isChecked" class="xieyi">我已阅读并同意
					</el-checkbox>
					<span @click="openXieYi" class="xieyi pointer">《使用协议》</span>
				</div>
				<el-button @click="registerSubmit" class="mt-15 register-btn" type="primary">立即注册</el-button>
				<div class="mt-5 tishi">注：审核需要1-5个工作日</div>
			</div>
		</div>

		<Footer class="mt-50" />

		<!-- 弹窗提示 -->
		<div class="dialog" v-if="isRegister">
			<div class="tc-box flex flex-column flex-center items-center">
				<img src="../assets/images/suc.png" alt="" />
				<div class="mt-10 name">已提交</div>
				<span class="mt-5 tips">审核结果将在一周内发送至您的手机</span>
			</div>
		</div>

		<!-- 协议弹窗 -->
		<el-dialog title="使用协议" :visible.sync="isDialog" width="50%" :before-close="handleClose">
			<div style="max-height: 400px; padding-bottom: 50px; overflow: scroll">
				<div v-html="html"></div>
			</div>
			<!-- <span slot="footer" class="dialog-footer">
        <el-button @click="isDialog = false">取 消</el-button>
        <el-button type="primary" @click="isDialog = false">确 定</el-button>
      </span> -->
		</el-dialog>

		<Result :title="resultTitle" :SubTitle="subTitle" :isShow="resultShow" @change="resultClose" />
	</div>
</template>

<script>
	import Footer from "@/components/Footer";
	import Result from "@/components/Result";
	export default {
		components: {
			Footer,
			Result,
		},
		data() {
			// 自定义校验密码规则
			var validatePass = (rule, value, callback) => {
				// var pwdZZ = /^[A-Za-z0-9]{8,}$/.test(value);
				var pwdZZ = /^(?=.*?\d)(?=.*?[A-Za-z])[\dA-Za-z]{8,}$/.test(value);
				// /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/.test(
				//   value
				// );
				if (value === "") {
					callback(new Error("请输入密码"));
				} else if (!pwdZZ) {
					callback(new Error("请输入密码(长度不少于8位，且必须包含数字和字母)"));
				} else {
					if (this.registerForm.checkPwd !== "") {
						this.$refs.registerFormRef.validateField("checkPwd");
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.registerForm.passWord) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};
			return {
				resultTitle: "",
				subTitle: "",
				resultShow: false,
				//供应商累心
				gongChengWuzi: [],
				html: '<p>尊敬的客户您好，欢迎您访问建捷通工程竞采平台。在您注册为平台会员之前，请您务必认真阅读和理解《用户注册协议》中所有的条款。您必须完成同意协议中所有的条款，才可以注册成为本平台的用户，使用其服务。您在本平台的注册和操作均将被视为是您对协议所有条款及内容的自愿接受。</p><p>一、声明</p><p>1)您在平台进行注册时，一旦勾选我已阅读并同意《使用协议》按钮，即表示为您已自愿接受协议中所有的条款和内容。</p><p>2)协议条款的效力范围仅限于本平台，您在平台的行为均受协议的约束。</p><p>3)您使用平台服务的行为，即被视为您已知悉本平台的相关公告并同意。</p><p>4)本平台有权在未提前通知您的情况下修改协议的条款。</p><p>5)本平台有权在未提前通知您的情况下修改，暂停平台部分或全部的服务，且不承担由此产生来自您和第三方的任何责任。</p><p>6)本平台提供免费注册服务，您的注册均是自愿行为，注册成功后，您可以得到本平台更加完善的服务。</p><p>7)您注册成为用户后账户和密码如有丢失，不会影响到您已办理成功业务的效力，本平台可恢复您的注册账户及相关信息。但不承但除此以外的其他任何责任。</p><p>二、用户管理</p><p>1)您在本平台的所有行为都须符合中国的法律法规，您不得利用平台提供的服务制作、复制、公布、传播以下信息：</p><p>①违反国家宪法基本原则的；</p><p>②危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一的；</p><p>③损害国家荣誉和利益的；</p><p>④煽动民族仇恨，民族歧视，破坏民族团结的；</p><p>⑤破坏国家宗教政策，宣扬邪教和封建迷信的；</p><p>⑥散步谣言，扰乱社会秩序，破坏社会稳定的；</p><p>⑦散布淫秽，色情，赌博，暴力，凶杀，恐怖内容或教唆犯罪的；</p><p>⑧侮辱或者诽谤他人，侵害他人合法权益的；</p><p>⑨以及法律法规禁止的其他内容。</p><p>2)您在本平台的行为必须符合其他国家和地区的法律法规以及国际法的相关规定。</p><p>3)不得利用本平台从事黑客行为。</p><p>4)遵守本平台其他规定和程序。</p><p>①您对自己在平台中的行为和操作承担全部责任；</p><p>②您承担责任的形式包括但不仅限于对受到侵害者进行赔偿；在平台首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予本平台等额赔偿；</p><p>③如果平台发现您的传输信息含有本协议所规定的内容，本平台有权在不通知您的情况下采取包括但不仅限于向国家有关机关报告，保存有关记录。删除该内容及链接地址，关闭服务器，暂停您账号的操作权限，停止向您提供服务等措施。</p><p>三、注册用户权利和义务</p><p>1)注册用户有权用平台提供发布服务功能。</p><p>2)注册用户必须同意不得违反国家相关规定。</p><p>3)您注册时有义务提供完整，真实的个人信息。</p><p>4)您注册后必须妥善保管账户密码，用户登陆后的一切活动均视为您本人的行为和意愿，您负全部责任。</p><p>5)您在使用本平台时，同意且接受本平台提供的各类服务。</p><p>6)您在使用本平台服务时禁止一切违规操作。</p><p>四、用户隐私</p><p>	我们承诺对您个人的信息和隐私安全承担保密义务，未经您同意，本平台不会</p><p>将您个人资料泄露，但以下情况除外，且平台不负责任。</p><p>1)政府有关部门要求本平台提供的；</p><p>2)由于您泄露的；</p><p>3)黑客攻击，病毒侵入的；</p><p>4)平台会与其他平台链接，但不对其负责；</p><p>5)您的有关记录有可能成为您违反法律法规和本协议的证据。</p><p>五、知识产权本</p><p>	平台所有的域名、商号、商标、文字、视像及声音内容，图形及图像均受有关所有权和知识产权法律保护，未经本平台事先以书面明确允许，任何人或单位，均不得进行复制和使用。</p><p>六、法律适用</p><p>1)协议由本平台的所有人负责修订，并通过本平台公布，您的注册行为即被视为您自愿接受协议的全部条款，受其约束；</p><p>2)协议的生效，履行，解释及争议的解决均适用我国法律；</p><p>3)您使用本平台的服务如产生争议，原则上双方协商解决，协商不成可向长治仲裁委员会申请仲裁。</p>',
				isCode: true,
				ms: 59,
				isChecked: false,
				labelPosition: "right",
				isRegister: false, //注册成
				//注册表单
				registerForm: {
					loginName: null,
					passWord: null,
					checkPwd: null,
					entrustLetter: null, //授权委托书路径
					letterValidityPeriod: null, //有效期
					authPerson: null, //姓名
					phone: null, //电话
					recommender: null,
					verifyCode: null, //验证码
					subType: null,
					supplierType: null, //
					supplierType1: null, //
					supplierName: null, //名称企业
					tariffLine: null, //税号
					businessLicense: null, //营业执照路径
					licenseValidityPeriod: null, //营业执照有效期
					depositBank: null, //开户行
					depositBranchBank: null, //分行
					openAccountName: null, //开户名称
					bankAccount: null, //对公账户
					openAccountLicence: null, //开户许可证文件路径
				},
				registerFormRules: {
					loginName: [{
						required: true,
						message: "请输入登录名",
						trigger: "blur"
					}, ],
					passWord: [{
						required: true,
						validator: validatePass,
						trigger: "blur"
					}, ],
					checkPwd: [{
						required: true,
						validator: validatePass2,
						trigger: "blur"
					}, ],
					supplierType1: [{
						required: true,
						message: "请输入登录名",
						trigger: "change"
					}, ],
					supplierName: [{
						required: true,
						message: "请输企业名称",
						trigger: "blur"
					}, ],
					tariffLine: [{
						required: true,
						message: "请输入税号",
						trigger: "blur"
					}, ],

					businessLicense: [{
						required: true,
						message: "请上传营业执照",
						trigger: "blur"
					}, ],
					licenseValidityPeriod: [{
						required: true,
						message: "请选择营业执照有效期",
						trigger: "blur",
					}, ],
					depositBank: [{
						required: true,
						message: "请选择银行",
						trigger: "change"
					}, ],

					openAccountName: [{
						required: true,
						message: "请输入开户名称",
						trigger: "blur"
					}, ],
					bankAccount: [{
						required: true,
						message: "请输入对公账户",
						trigger: "blur"
					}, ],
					entrustLetter: [{
						required: true,
						message: "请上传授权委托书",
						trigger: "blur"
					}, ],
					letterValidityPeriod: [{
						required: true,
						message: "请选择授权委托书有效期",
						trigger: "change",
					}, ],
					authPerson: [{
						required: true,
						message: "请输入被授权人",
						trigger: "blur"
					}, ],
					phone: [{
						required: true,
						message: "请输入手机号码",
						trigger: "blur"
					}],
					verifyCode: [{
						required: true,
						message: "请输入手机验证码",
						trigger: "blur"
					}, ],
					depositBranchBank: [{
						required: true,
						message: "请输入分行名称",
						trigger: "blur"
					}, ],
				},
				gongYingShangType: [],
				gongYingShangSubType: [],
				isDialog: false,
				fileList: [],
				disabled: false,
				fileName: "",
				isSubType: false,
				isGoIndex: false,
			};
		},
		mounted() {
			this.getGongYingShangType();
			// this.getGongYingShangSubType();
		},
		methods: {
			//下载模板
			downMuBan() {
				window.open(
					// "http://81.70.253.119:8081/common/download?fileName=/授权委托书模板.doc"
					this.$static.SERVER_URL + "/common/download?fileName=/授权委托书模板.doc"
				);
			},
			resultClose() {
				this.resultShow = false;
				if (this.isGoIndex) {
					this.$router.push("/index");
				}
			},
			typeChange(val) {
				// if (val == 4) {
					this.isSubType = true;
					this.registerForm.supplierType = val;
					this.registerForm.subType = "";
					this.gongChengWuzi = [];
					this.getGongYingShangSubType(val);
					
				// } else {
				// 	this.isSubType = false;
				// 	this.registerForm.supplierType = val;
				// }
			},
			subTypeChange(val) {
				// console.log(val.join(";"));
				this.registerForm.subType = val.join(";");
			},
			ShuiHaoInput(val) {
				let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
					len = val.length,
					str = "";
				for (var i = 0; i < len; i++) {
					if (codeReg.test(val[i])) {
						str += val[i];
					}
				}
				this.registerForm.tariffLine = str;
			},
			handleClose() {
				this.isDialog = false;
			},
			//打开协议
			openXieYi() {
				this.isDialog = true;
			},
			//打开图片
			openImg(url) {
				window.open(url);
			},
			//文件上传成功
			fileUploadSuc(res) {
				if (res.code == "200") {
					// this.$message.success(res.msg);
					this.resultTitle = "上传成功";
					this.subTitle = res.msg;
					this.resultShow = true;
					// this.isGoIndex = true;
					this.registerForm.businessLicense =
						// "http://81.70.253.119:8081" + res.fileName;
						this.$static.SERVER_URL + res.fileName;
					// this.fileList[0].url = res.url;
					// console.log(this.fileList);
				} else {
					this.resultTitle = "上传失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
			},
			handleRemove(file) {
				console.log(file);
			},
			fileUploadSuc1(res) {
				if (res.code == "200") {
					this.resultTitle = "上传成功";
					this.subTitle = res.msg;
					this.resultShow = true;
					this.registerForm.openAccountLicence =
						// "http://81.70.253.119:8081" + res.fileName;
						this.$static.SERVER_URL + res.fileName;
				} else {
					this.resultTitle = "上传失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
			},
			fileUploadSuc2(res) {
				if (res.code == "200") {
					this.resultTitle = "上传成功";
					this.subTitle = res.msg;
					this.resultShow = true;
					this.registerForm.entrustLetter =
						// "http://81.70.253.119:8081" + res.fileName;
						this.$static.SERVER_URL + res.fileName;
				} else {
					this.resultTitle = "上传失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
			},
			fileProgress(e, file) {
				console.log(e);
				console.log(file);
				this.fileName = file.name;
			},
			//获取供应商类型
			async getGongYingShangType() {
				const {
					data: res
				} = await this.$axios.get("/api/common/getDictData", {
					params: {
						dictType: "supplier_type",
					},
				});
				if (res.code == 200) {
					this.gongYingShangType = res.data;
				} else {
					this.resultTitle = "获取失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
			},
			async getGongYingShangSubType(supplierType) {
				const {
					data: res
				} = await this.$axios.get("/api/common/getSubTypeList", {
					params: {
						type: supplierType,
					},
				});
				if (res.code == 200) {
					this.gongYingShangSubType = res.data;
				} else {
					this.resultTitle = "获取失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
			},
			//点击获取验证码
			async getCode() {
				if (!this.registerForm.phone) {
					this.resultTitle = "操作失败";
					this.subTitle = "请输入手机号";
					this.resultShow = true;
					return;
				}
				//请求验证码
				const {
					data: res
				} = await this.$axios.get("/api/verifyCode/getCode", {
					params: {
						type: 2,
						phone: this.registerForm.phone,
					},
				});
				if (res.code == 200) {
					this.resultTitle = "发送成功";
					this.subTitle = res.msg;
					this.resultShow = true;
					this.isCode = false;
					let timer = null;
					timer = setInterval(() => {
						if (this.ms > 0) {
							--this.ms;
						} else {
							this.isCode = true;
							this.ms = 59;
							clearInterval(timer);
						}
					}, 1000);
				} else {
					this.resultTitle = "发送失败";
					this.subTitle = res.msg;
					this.resultShow = true;
				}
			},
			// 点击注册
			async registerSubmit() {
				if (!this.isChecked) {
					this.resultTitle = "操作失败";
					this.subTitle = "请先阅读并同意使用协议";
					this.resultShow = true;
					return;
				}
				this.$refs.registerFormRef.validate(async (valid) => {
					if (!valid) {
						return;
					}
					let obj = {
						userInfo: {
							loginName: this.registerForm.loginName,
							passWord: this.registerForm.passWord,
							entrustLetter: this.registerForm.entrustLetter,
							letterValidityPeriod: this.registerForm.letterValidityPeriod,
							authPerson: this.registerForm.authPerson,
							recommender: this.registerForm.recommender,
							phone: this.registerForm.phone,
							verifyCode: this.registerForm.verifyCode,
						},
						// authInfo: {

						// },
						supplierInfo: {
							supplierType: this.registerForm.supplierType,
							subType: this.gongChengWuzi.join(";"),
							supplierName: this.registerForm.supplierName,
							tariffLine: this.registerForm.tariffLine,
							businessLicense: this.registerForm.businessLicense,
							licenseValidityPeriod: this.registerForm.licenseValidityPeriod,
							depositBank: this.registerForm.depositBank,
							depositBranchBank: this.registerForm.depositBranchBank,
							openAccountName: this.registerForm.openAccountName,
							bankAccount: this.registerForm.bankAccount,
							openAccountLicence: this.registerForm.openAccountLicence,
						},
					};
					const {
						data: res
					} = await this.$axios.post(
						"/api/userInfo/userRegister",
						obj
					);
					if (res.code == "200") {
						this.resultTitle = "注册成功";
						this.subTitle = res.msg;
						this.resultShow = true;
						this.isRegister = true;
						this.isGoIndex = true;
						// setTimeout(() => {
						//   this.isRegister = false;
						//   this.$router.push("/login");
						// }, 2000);
					} else {
						this.resultTitle = "注册失败";
						this.subTitle = res.msg;
						this.resultShow = true;
					}
				});
			},
			//图片上传接口
			// handlePreview() {},
			// handleRemove() {},
			// beforeRemove() {},
			handleExceed() {},
			//登录
			goLogin() {
				this.$router.push("/login");
			},
			//回首页
			goIndex() {
				this.$router.push("/index");
			},
		},
	};
</script>

<style scoped lang="less">
	.upload-img {
		max-width: 100%;
		height: 40px;
	}

	/deep/.el-card {
		border: none !important;
	}

	/deep/.el-card__body {
		padding: 0 !important;
	}

	/deep/.header-card.el-card.is-always-shadow {
		box-shadow: 0px 3px 6px rgb(204 217 233 / 70%);
	}

	// 头部
	.header-card {
		position: relative;
		z-index: 100;
	}

	.login-header {
		width: 1200px;
		height: 84px;
		margin: 0 auto;

		.logo {
			width: 330px;
			// background-color: #1c65c4;
			height: 84px;
			color: #fff;
			text-align: center;
			line-height: 84px;
		}

		h1 {
			line-height: 84px;
			font-size: 36px;
			margin-left: 50px;
		}

		.back {
			width: 176px;
			box-sizing: border-box;
			height: 40px;
			border-radius: 20px;
			border: 1px solid #1c65c4;
			color: #1c65c4;
			text-align: center;
			line-height: 40px;
			font-size: 16px;
			font-weight: bold;
		}
	}

	// 表单开
	.content {
		width: 1200px;
		margin: 0 auto;
		padding-top: 50px;

		.title {
			margin-top: 60px;

			.name {
				font-size: 20px;
				font-weight: bold;
				color: #3b426b;
			}

			.tips {
				font-size: 14px;
				color: #ccd9e9;
			}
		}

		.acount {
			// height: 240px;
			width: 1200px;
			background-color: #fff;
			margin: 0 auto;
			box-shadow: 0px 0px 15px rgba(28, 101, 196, 0.3);
			margin-top: 24px;
			padding-top: 50px;
			padding-bottom: 50px;

			/deep/.el-input__inner {
				background-color: #f7f9fc;
				border: none;
				font-size: 14px;
				width: 320px;
				// color: #ccd9e9;
			}

			/deep/.upload.el-input {
				width: 246px;
			}

			/deep/.upload .el-input__inner {
				background-color: #f7f9fc;
				border: none;
				font-size: 14px;
				width: 246px !important;
				// color: #ccd9e9;
			}

			/deep/.upload.el-button--small {
				border: none;
				font-size: 14px;
				color: #02224b;
			}

			/deep/.upload.el-button:hover {
				background-color: #fff;
				// font-size: 14px;
			}

			/deep/.selcet .el-input__inner {
				width: 146px;
			}

			/deep/.selcet1 .el-input__inner {
				width: 156px;
			}

			.kaihu {
				width: 246px;
				height: 79px;
				background-color: #f7f9fc;
				line-height: 16px;
				color: #ccd9e9;
				font-size: 14px;
			}

			.kaihu-btn {
				width: 320px;
				line-height: 40px;
				text-align: center;
				color: #fff;
				background-color: #95b3db;
				border-radius: 5px;
			}

			.ml-18 {
				margin-left: 18px;
			}

			//授权
			.text {
				font-size: 14px;
				color: #02224b;
				font-weight: bold;
			}

			/deep/.shouquan .el-input__inner {
				width: 154px;
			}

			/deep/.shouquan.el-input {
				width: 154px;
			}

			/deep/.code .el-input__inner {
				width: 160px;
			}

			/deep/.code.el-input {
				width: 160px;
			}

			/deep/.phone .el-input__inner {
				width: 232px;
			}

			/deep/.phone.el-input {
				width: 232px;
			}

			.code {
				font-size: 14px;
				color: #3b426b;
			}

			.text1 {
				color: #3b426b;
				line-height: 14px;
			}

			.text2 {
				color: #ccd9e9;
				line-height: 14px;
			}

			.yzm,
			.phonew {
				width: 320px;
			}
		}
	}

	.xieyi {
		color: #02224b;
		font-size: 14px;
		font-weight: bold;
	}

	/deep/.xieyi .el-checkbox__label {
		color: #02224b;
		font-size: 14px;
	}

	/deep/.el-form-item__label {
		text-align: right;
		color: #02224b;
		font-size: 14px;
	}

	/deep/.register-btn.el-button {
		background-color: #1c65c4;
		color: #fff;
		font-size: 14px;
		width: 320px;
	}

	.tishi {
		font-size: 14px;
		color: #95b3db;
	}

	// 弹窗
	.dialog {
		width: 100%;
		height: 100%;
		background-color: rgba(28, 101, 196, 0.05);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10000;

		.tc-box {
			width: 605px;
			height: 300px;
			background-color: #fff;
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			.name {
				font-size: 18px;
				color: #3b426b;
			}

			.tips {
				font-size: 14px;
				color: #ccd9e9;
			}
		}
	}
</style>
